import { render, staticRenderFns } from "./chongzhi.vue?vue&type=template&id=6fc63cd7&scoped=true"
import script from "./chongzhi.vue?vue&type=script&lang=js"
export * from "./chongzhi.vue?vue&type=script&lang=js"
import style0 from "./chongzhi.vue?vue&type=style&index=0&id=6fc63cd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc63cd7",
  null
  
)

export default component.exports